





















































































































































import { Component, Vue } from "vue-property-decorator";
import Agency from "@/store/entities/agency";
import Ajax from "@/lib/ajax";

interface ApiUserResult {
  username: string;
  password: string;
  refId: number;
}

@Component
export default class ApiUserCreate extends Vue {
  valid: boolean = false;
  loading: boolean = false;
  selectedAgency: number | null = null;
  agencies: Agency[] = [];
  apiUserCreated: boolean = false;
  apiUserResult: ApiUserResult = {
    username: '',
    password: '',
    refId: 0
  };
  breadcrumbsItems: any[] = [];

  async created() {
    await this.getAgencies();
    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Kullanıcılar", disabled: true },
      { text: "API Kullanıcısı Oluştur", disabled: true },
    ];
  }

  async getAgencies() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });
    this.agencies = this.$store.state.agency.list;
  }

  async createApiUser() {
    if (!this.selectedAgency) {
      return;
    }

    this.loading = true;
    try {
      const response = await Ajax.post('/api/services/app/Admin/CreateApiUser', {
        agencyId: this.selectedAgency
      });

      if (response.data && response.data.result) {
        this.apiUserResult = {
          username: response.data.result.username,
          password: response.data.result.password,
          refId: response.data.result.refId
        };
        this.apiUserCreated = true;
        
        Vue.$toast.success("API kullanıcısı başarıyla oluşturuldu!");
      }
    } catch (error) {
      console.error('API kullanıcısı oluşturulurken hata:', error);
      Vue.$toast.error("API kullanıcısı oluşturulurken hata oluştu!");
    } finally {
      this.loading = false;
    }
  }

  async copyToClipboard(text: string, label: string) {
    try {
      await navigator.clipboard.writeText(text);
      Vue.$toast.success(`${label} kopyalandı!`);
    } catch (error) {
      console.error('Kopyalama hatası:', error);
      Vue.$toast.error("Kopyalama başarısız!");
    }
  }

  getLoginJson() {
    return JSON.stringify({
      "usernameOrEmailAddress": this.apiUserResult.username,
      "password": this.apiUserResult.password
    }, null, 2);
  }

  async copyAllCredentials() {
    const credentialsText = `${this.getLoginJson()}
refId: ${this.apiUserResult.refId}
api-document: https://apidoc.novaavia.net/`;

    try {
      await navigator.clipboard.writeText(credentialsText);
      Vue.$toast.success("Tüm bilgiler kopyalandı!");
    } catch (error) {
      console.error('Kopyalama hatası:', error);
      Vue.$toast.error("Kopyalama başarısız!");
    }
  }

  resetForm() {
    this.apiUserCreated = false;
    this.selectedAgency = null;
    this.apiUserResult = {
      username: '',
      password: '',
      refId: 0
    };
    (this.$refs.form as any).resetValidation();
  }
}
